import { projectsApiClient } from "../common/axiosInstanceProjects";
import { handleAxiosError } from "../common/handleAxiosError";
import { IProjectsData } from "./types";

export interface ProjectsResponse {
  data: IProjectsData[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const getAllProjects = async (page: number = 1, limit: number = 10): Promise<ProjectsResponse> => {
  try {
    const response = await projectsApiClient.get("/projects", {
      params: {
        page,
        limit
      }
    });
    
    // Si el backend ya soporta paginación, usar la respuesta tal como viene
    if (response.data && response.data.total !== undefined) {
      return response.data;
    }
    
    // Si el backend no soporta paginación aún, simularla
    const allProjects = response.data.data || response.data || [];
    const total = allProjects.length;
    const totalPages = Math.ceil(total / limit);
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = allProjects.slice(startIndex, endIndex);
    
    return {
      data: paginatedData,
      total,
      page,
      limit,
      totalPages
    };
  } catch (error) {
    handleAxiosError(error, "Error al obtener los proyectos");
    throw error;
  }
};